// src/utils/config.js
import { Preferences } from '@capacitor/preferences';

// Key for saved server URL
const SERVER_URL_KEY = 'CUSTOM_SERVER_URL';

/**
 * Get the effective API base URL:
 * 1. Saved user URL (if any)
 * 2. Fallback to window.APP_CONFIG.api1.baseapi
 */
export const getApiBase = async () => {
  // In dev, let CRA proxy handle relative URLs
  if (process.env.NODE_ENV === 'development') {
    return ''; // proxy will forward "/"
  }

  // 1. Check saved URL
  const { value } = await Preferences.get({ key: SERVER_URL_KEY });
  if (value) {
    return value.trim().replace(/\/+$/, '');
  }

  // 2. Fallback to config.js
  return window.APP_CONFIG?.api1?.baseapi || '';
};

/**
 * Save new server URL (user input)
 */
export const setApiBase = async (url) => {
  const clean = url.trim().replace(/\/+$/, '');
  await Preferences.set({ key: SERVER_URL_KEY, value: clean });

  // Also update window.APP_CONFIG so future code sees it
  if (window.APP_CONFIG) {
    window.APP_CONFIG.api1.baseapi = clean;
    window.APP_CONFIG.api2.baseapi = clean;
  }
};

/**
 * Get current URL (for display in settings)
 */
export const getCurrentApiBase = async () => {
  const { value } = await Preferences.get({ key: SERVER_URL_KEY });
  return value || window.APP_CONFIG?.api1?.baseapi || '';
};